import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './Loader.module.scss'

export const Loader: FunctionComponent<Props> = ({ className, color = 'Red', ...rest }) => {
  const loaderColorStyle = `loader${color}`

  return (
    <svg
      aria-hidden
      className={classnames(styles.loader, styles[loaderColorStyle], className)}
      data-testid="svg"
      focusable="false"
      shapeRendering="geometricPrecision"
      tabIndex={-1}
      textRendering="geometricPrecision"
      version="1.1"
      viewBox="0 0 67 25"
      xlinkHref="https://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      xmlns="https://www.w3.org/2000/svg"
      {...rest}
    >
      <ellipse className={styles.pip1} fill="currentColor" rx="8.5" ry="8.5" stroke="none" />
      <ellipse className={styles.pip2} fill="currentColor" rx="8.5" ry="8.5" stroke="none" />
      <ellipse className={styles.pip3} fill="currentColor" rx="8.5" ry="8.5" stroke="none" />
    </svg>
  )
}

///////// IMPLEMENTATION /////////

export type Props = {
  /**
   * classname to provide positioning within consuming app
   */
  className?: string
  /**
   *  The colour of the animated pips
   */
  color?: 'Red' | 'White' | 'Grey'
} & ComponentPropsWithoutRef<'svg'>
